import { render, staticRenderFns } from "./DiscontinuanceStep.vue?vue&type=template&id=bb69606e"
import script from "./DiscontinuanceStep.vue?vue&type=script&lang=ts"
export * from "./DiscontinuanceStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports